import { Card, CardContent } from '@/components/ui/card';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';

export const PublicationSkeleton = () => {
  return (
    <div className="mx-auto flex w-full max-w-2xl lg:max-w-3xl flex-col items-center px-4">
      <Card className="w-full rounded-2xl bg-slate-100 p-6 shadow-xl">
        <div className="flex flex-col md:flex-row lg:flex-row lg:gap-4">
          {/* Columna izquierda: carrusel + info */}
          <div className="flex flex-col items-center md:w-1/2 lg:w-1/2">
            <div className="mb-2 flex w-full flex-row items-center justify-between">
              <div className="h-6 w-6 animate-pulse rounded-full bg-slate-400" />
              <div className="h-8 w-32 animate-pulse rounded-lg bg-slate-400" />
              <div className="h-6 w-6 animate-pulse rounded-full bg-slate-400" />
            </div>

            <Carousel className="relative mx-auto mb-4 w-full max-w-xs lg:max-w-full">
              <CarouselContent>
                <CarouselItem>
                  <div className="flex animate-pulse justify-center p-4">
                    <div className="h-[280px] w-[280px] rounded-lg bg-slate-300" />
                  </div>
                </CarouselItem>
              </CarouselContent>
              <CarouselPrevious className="absolute left-[1px] top-1/2 z-10 -translate-y-1/2 transform" />
              <CarouselNext className="absolute right-[1px] top-1/2 z-10 -translate-y-1/2 transform" />
            </Carousel>

            <CardContent className="mt-4 w-full">
              <div className="flex h-[248px] animate-pulse flex-col gap-2 rounded-lg bg-slate-300 p-2"></div>
            </CardContent>
          </div>

          {/* Columna derecha: mapa + botones */}
          <div className="flex flex-col md:w-1/2 lg:w-1/2">
            <div className="relative mx-auto h-full min-h-[300px] w-full flex-grow">
              <div className="absolute inset-0 h-full w-full animate-pulse rounded-lg bg-slate-300" />
            </div>

            <div className="flex flex-row items-center justify-between gap-2 p-4 text-sm font-bold">
              <div className="h-6 w-24 animate-pulse rounded bg-slate-300" />
              <div className="h-6 w-20 animate-pulse rounded bg-slate-300" />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
